"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = __importDefault(require("react"));

require("./ExcelPPTLibraryItemCard.css");

var LibraryItemAutosync = function (_a) {
  var sourceName = _a.sourceName,
      groupName = _a.groupName,
      sharePointItemUrl = _a.sharePointItemUrl,
      fileName = _a.fileName;

  var displaySourceName = function (s) {
    if (groupName) {
      // PPT
      var slideName = s.replace(groupName, '').trimEnd();
      return slideName + ", " + groupName;
    } // Excel


    var replaced = s.replace(/['|$]/g, '').trimEnd();

    var _a = replaced.split('!'),
        first = _a[0],
        second = _a[1];

    return second ? first + ", " + second : first;
  };

  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: sourceName && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "content-item-link"
    }, {
      children: ["Autosynced from", ' ', sourceName && "'" + displaySourceName(sourceName) + "' in ", (0, jsx_runtime_1.jsx)("a", __assign({
        href: sharePointItemUrl + "?web=1",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "external-source-link content-item-link-ref",
        "data-testid": "autosynced-soure-external-source"
      }, {
        children: fileName
      }), void 0)]
    }), void 0)
  }, void 0);
};

exports.default = react_1.default.memo(LibraryItemAutosync);